export default __webpack_public_path__ + "static/media/ping.d72ff651.wav";